import { Pipe, PipeTransform } from '@angular/core';
import { Language } from '../constant/languages';

@Pipe({
  name: 'languageDisplay',
  standalone: false, // eslint-disable-line
})
export class LanguageDisplayPipe implements PipeTransform {
  transform(language: Language): string {
    if (!language) {
      return '';
    }
    return language.region ? `${language.name} (${language.region})` : language.name;
  }
}
